export default "__VITE_ASSET__CBJ2q3kd__"